var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 17,
  fill: "none",
  viewBox: "0 0 15 17",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#51A196",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14 7.136C14 11.91 7.5 16 7.5 16S1 11.91 1 7.136c0-1.627.685-3.188 1.904-4.339C4.123 1.647 5.776 1 7.5 1s3.377.647 4.596 1.797C13.316 3.948 14 5.51 14 7.137"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#51A196",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M7.5 9.182c1.197 0 2.167-.916 2.167-2.046S8.697 5.091 7.5 5.091s-2.167.916-2.167 2.045.97 2.046 2.167 2.046"
})));
export { SvgMapIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/mapIcon.svg";